/**
 * component-mobile-menu.js
 * Itération 2026-05-04 Batch 2 — Item Mobile #1.
 *
 * Custom Element <edj-mobile-menu> qui gère :
 *  - ouverture / fermeture du drawer mobile
 *  - blocage du scroll body
 *  - fermeture sur clic overlay, bouton X, touche Escape
 *  - fermeture sur clic d'un lien interne (laisser la nav suivre son cours)
 *  - synchro de aria-expanded/aria-hidden sur le bouton & dialog
 */
class EdjMobileMenu extends HTMLElement {
  constructor() {
    super();
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this.dialog = this.querySelector('.edj-mobile-menu');
    this.panel = this.querySelector('.edj-mobile-menu__panel');
    this.overlay = this.querySelector('.edj-mobile-menu__overlay');
    if (!this.dialog || !this.panel) return;

    // Boutons d'ouverture (peuvent être hors du <edj-mobile-menu>) — on délègue au document.
    document.addEventListener('click', this._onClick);
    document.addEventListener('keydown', this._onKeyDown);

    // Fermer au clic sur un lien (sans bloquer la navigation)
    this.querySelectorAll('a[href]').forEach(a => {
      a.addEventListener('click', () => this.close());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onClick);
    document.removeEventListener('keydown', this._onKeyDown);
  }

  _onClick(e) {
    const opener = e.target.closest('[data-action="open-mobile-menu"]');
    if (opener) {
      e.preventDefault();
      this.open();
      return;
    }
    const closer = e.target.closest('[data-action="close-mobile-menu"]');
    if (closer) {
      e.preventDefault();
      this.close();
    }
  }

  _onKeyDown(e) {
    if (e.key === 'Escape' && this.isOpen()) this.close();
  }

  isOpen() {
    return this.dialog && this.dialog.hasAttribute('open');
  }

  open() {
    if (!this.dialog || this.isOpen()) return;
    this.dialog.hidden = false;
    // Force reflow so transition kicks in
    void this.dialog.offsetWidth;
    this.dialog.setAttribute('open', '');
    this.dialog.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('edj-mobile-menu-open');
    document.body.classList.add('edj-mobile-menu-open');
    const trigger = document.querySelector('[data-action="open-mobile-menu"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (this.panel) this.panel.focus();
  }

  close() {
    if (!this.dialog || !this.isOpen()) return;
    this.dialog.removeAttribute('open');
    this.dialog.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('edj-mobile-menu-open');
    document.body.classList.remove('edj-mobile-menu-open');
    const trigger = document.querySelector('[data-action="open-mobile-menu"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    // Hide after transition
    setTimeout(() => {
      if (!this.isOpen()) this.dialog.hidden = true;
    }, 320);
  }
}

if (!customElements.get('edj-mobile-menu')) {
  customElements.define('edj-mobile-menu', EdjMobileMenu);
}
